import React from 'react';
import { shadeColor } from '../../utils/shadeColor';

import { BadgeSize } from '../../types/BadgeSize';
import { GlowRing, ShimmerLayer, StyledBadge } from './styles';

type BadgeProps = {
  label: string;
  backgroundColor: string;
  isGradient?: boolean;
  size?: BadgeSize;
};

export const Badge: React.FC<BadgeProps> = ({
  label,
  backgroundColor,
  isGradient = false,
  size = 'medium',
}) => {
  const lighterColor = shadeColor(backgroundColor, 30);
  const darkerColor = shadeColor(backgroundColor, -35);

  const backgroundStyle = isGradient
    ? `linear-gradient(135deg, ${lighterColor} 0%, ${backgroundColor} 45%, ${darkerColor} 100%)`
    : `linear-gradient(135deg, ${shadeColor(
        backgroundColor,
        15,
      )} 0%, ${backgroundColor} 50%, ${darkerColor} 100%)`;

  return (
    <StyledBadge
      background={backgroundStyle}
      baseColor={backgroundColor}
      size={size}
    >
      <GlowRing baseColor={backgroundColor} />
      <ShimmerLayer />
      <span className="badge-label">{label?.toUpperCase()}</span>
    </StyledBadge>
  );
};
